import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckLoginGuard } from './shared/guards/check-login.guard';
import { PreloadAllModules } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
  { path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule) },
  {
    path: 'login', loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginModule),
    canActivate: [CheckLoginGuard]
  },
  {
    path: 'auth/callback',
    loadChildren: () => import('./pages/auth/auth-callback/auth-callback.module').then(m => m.AuthCallbackModule)
  },
  {
    // Pública, sin CheckLoginGuard: la firma la realiza el trabajador desde el link,
    // no un usuario autenticado del sistema.
    path: 'firma-entrega',
    loadChildren: () => import('./pages/firma-entrega/firma-entrega.module').then(m => m.FirmaEntregaModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
